const t=(e="",i=100)=>e.length>i?t(e.split("|").slice(0,-1).join("|"),i):e;export{t as limitPipedString};
